export const BEMPrefix = 'plauditQueryLoop__group--';
export const autoUpdateSelector = `.${BEMPrefix}autoUpdate`;
export const updatingClass = `${BEMPrefix}updating`;

export const formUpdatingClass = "plauditQueryLoop__form--updating";

export type FormishElement = HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement;
export function isFormishElement(element: any): element is FormishElement {
	return element instanceof Element && 'form' in element && (element.form === null || element.form instanceof HTMLFormElement);
}

export function isResettableFormishElement(element: any): element is FormishElement {
	return isFormishElement(element) && element.classList.contains('plauditQueryLoopField__input');
}

export function isAutoSubmittableFormishElement(element: any): element is FormishElement {
	return isResettableFormishElement(element) && element.getAttribute("data-auto-submit") !== 'off'
		&& element.closest(".plauditQueryLoopField__fieldArea")?.getAttribute("data-auto-submit") !== 'off';
}

export function fixSquareBracketsInURL(url: string) {
	const hashIndex = url.indexOf('#');
	let target = hashIndex === -1 ? url : url.substring(0, hashIndex);
	let oldLength: number;
	do {
		oldLength = target.length;
		target = target.replace(/([?&])([^=&]*)(&|=[^&]*|$)/g, (match, g1, g2, g3) => `${g1}${g2.replace("%5B", '[').replace("%5D", ']')}${g3}`);
	} while(target.length !== oldLength);
	return hashIndex === -1 ? target : target + url.substring(hashIndex);
}
